import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommunityService } from '../../../services/community.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule, Location } from '@angular/common';
import { FreelancerDataService } from '../../../services/freelancer-data.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { DomainService } from '../../domain/domain.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

@Component({
  selector: 'app-job-applicants',
  standalone: true,
  imports: [CommonModule, NgxPaginationModule, NgxDocViewerModule],
  templateUrl: './job-applicants.component.html',
  styleUrl: './job-applicants.component.css'
})
export class JobApplicantsComponent implements OnInit {
  communityID!: number;
  slug!: string;

  // server payload
  post: any = null;

  applicants: any[] = [];
  totalApplicants = 0;
  totalPages = 0;

  isLoading = true;
  currentPage = 1;
  limit = 10;

  pages: number[] = [];

  availabiltyDurations: any[] = [];

  // profile modal
  selectedUser: any;
  resumeViewerUrl: string | null = null;
  @ViewChild('profileModal') profileModal!: TemplateRef<any>;
  userID!: number;
  jobID!: number;
  showApllicantsList: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private communityService: CommunityService,
    private toastr: ToastrService,
    private dataService: FreelancerDataService,
    public domainService: DomainService,
    private modalService: NgbModal,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.slug = params['slug'];
      this.communityID = +params['communityId'];
      this.jobID = +params['postID'];
      this.loadApplicants();
    });
  }

  loadApplicants(page: number = 1): void {
    this.isLoading = true;
    this.getConsultantRegistrationDataList();

    this.communityService.getjobApplicants(this.communityID, this.jobID, { page, limit: this.limit })
      .subscribe({
        next: (res) => {
          const body = res?.data?.body || {};
          this.post = body.post || null;
          this.applicants = body.applicants || [];
          this.totalApplicants = body.pagination?.total || this.applicants.length || 0;
          if(body.ka_recruiter_job == true) {
            this.showApllicantsList = false;
          }else{
            this.showApllicantsList = true;
          }

          const totalPages = body.pagination?.totalPages || 1;
          this.totalPages = totalPages;
          this.currentPage = page;
          this.pages = Array.from({ length: totalPages }, (_, i) => i + 1);

          this.isLoading = false;
        },
        error: () => {
          this.toastr.error('Failed to load applicants');
          this.isLoading = false;
        }
      });
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.loadApplicants(page);
  }

  getConsultantRegistrationDataList(): void {
    this.dataService.getconsultantRegistration().subscribe({
      next: (res) => {
        const consultantRegistration = res?.data;
        this.availabiltyDurations = consultantRegistration?.durations || [];
      },
      error: (err) => {
        console.error('Error fetching consultant registration:', err);
      }
    });
  }

  // -------- Availability helpers --------
  getDurationLabel = (id: number | null): string => {
    if (!id || id === 8) return '';
    const found = this.availabiltyDurations.find(d => d.duration_id === id);
    return found ? found.value : '';
  };

  getAvailabilityStatus = (av: { start_at: string | null; duration_id: number | null }): string => {
    const today = new Date(); today.setHours(0,0,0,0);
    const start = av?.start_at ? new Date(av.start_at) : null;
    if (start) start.setHours(0,0,0,0);
    const raw = av?.duration_id ? this.getDurationLabel(av.duration_id) : '';
    const show = raw && raw !== 'Unknown' ? raw : null;
    if (!start || start <= today) return show ? `Available Now (${show})` : 'Available Now';
    const formatted = start.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    return show ? `Available From ${formatted} (${show})` : `Available From ${formatted}`;
  };

  getAvailabilityBadgeClass = (av: { start_at: string | null; duration_id: number | null }): string => {
    const today = new Date(); today.setHours(0,0,0,0);
    const startAt = av?.start_at ? new Date(av.start_at) : null;
    if (startAt) startAt.setHours(0,0,0,0);
    return !startAt || startAt <= today ? 'bg-success text-white' : 'bg-warning text-dark';
  };

  // -------- Pagination helpers --------
  get showingFrom(): number {
    return this.totalApplicants === 0 ? 0 : (this.currentPage - 1) * this.limit + 1;
  }
  get showingTo(): number {
    const end = this.currentPage * this.limit;
    return end > this.totalApplicants ? this.totalApplicants : end;
  }

  // -------- Job parser for summary --------
  parseJob(content: string | null | undefined) {
    const lines = (content || '')
      .split(/\r?\n/)
      .map(l => l.trim())
      .filter(Boolean);

    const pick = (keys: string[]) => {
      const idx = lines.findIndex(l => keys.some(k => l.toLowerCase().startsWith(k)));
      if (idx === -1) return '';
      const parts = lines[idx].split(':'); parts.shift();
      return parts.join(':').trim();
    };

    const title       = pick(['job title', 'designation', 'title']);
    const description = pick(['description', 'desc']);
    const location    = pick(['location', 'loc']);
    const startDate   = pick(['start date', 'start']);
    const duration    = pick(['duration', 'notice']);

    return { title, description, location, startDate, duration };
    }

  // -------- Profile modal --------
  openProfile(user: any) {
    this.userID = user.user_id;
    this.communityService.getUserPublicProfile(this.communityID, this.userID).subscribe({
      next: (res) => {
        this.selectedUser = res?.data?.data || null;
        this.resumeViewerUrl = this.selectedUser?.resume_url || null;

        this.modalService.open(this.profileModal, {
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        });
      },
      error: () => {
        this.toastr.error('Failed to load user profile.');
      },
    });
  }


  getTelLink(raw: string | null | undefined): string {
    if (!raw) return '#';

    const tel = String(raw).replace(/\s+/g, '');
    return `tel:${tel}`;
  }

  getWhatsAppLink(raw: string | null | undefined): string {
    if (!raw) return '#';
    // wa.me expects only digits with country code (no "+" or spaces)
    const digits = String(raw).replace(/[^\d]/g, '');
    return `https://wa.me/${digits}`;
  }

 goBack(): void {
    this.location.back();
  }
}
